import PropTypes from 'prop-types';

export const templatePropTypes = {
	ctaButtonData: PropTypes.shape({
		ctaUrl: PropTypes.string,
		ctaLabel: PropTypes.string
	}).isRequired,
	description: PropTypes.elementType,
	detailsButtonData: PropTypes.shape({
		id: PropTypes.string,
		type: PropTypes.string
	}).isRequired,
	imageUrl: PropTypes.string,
	title: PropTypes.elementType.isRequired
};

export const promoPropTypes = {
	aspectRatio: PropTypes.string.isRequired,
	carouselPosition: PropTypes.number.isRequired,
	ctaLabel: PropTypes.string.isRequired,
	ctaUrl: PropTypes.string.isRequired,
	description: PropTypes.string,
	id: PropTypes.string.isRequired,
	imageUrl: PropTypes.string,
	isMobile: PropTypes.bool,
	isVisible: PropTypes.bool,
	promo: PropTypes.shape({}).isRequired,
	loadPromo: PropTypes.bool,
	title: PropTypes.string,
	type: PropTypes.string.isRequired
};
